const getPercentageValue = (value) => (value || value === 0 ? Number((parseFloat(value) * 100).toPrecision(4)) : '');

export default getPercentageValue;
